module.exports = __webpack_public_path__ + "media/images/centre d'affaires-d116fabfc300cd1e99d9258a66661120.svg";